import { createStubImplementation } from '@ardoq/stub-implementation';
import type { ArdoqError } from '@ardoq/common-helpers';

type Team =
  | 'engagement'
  | 'core'
  | 'impact'
  | 'insight'
  | 'appsec'
  | 'integrations';

type SentryTags = { team: Team };

type ExtraData = {
  [key: string | number]: unknown;
  tags?: SentryTags;
  /**
   * Sentry fingerprint array. When set, controls how Sentry groups this
   * event into issues. Use to produce one issue per logical occurrence
   * rather than relying on stack-based grouping.
   */
  fingerprint?: string[];
};

export type Logger = (
  error: ArdoqError | Error,
  message?: string | null,
  extraData?: ExtraData
) => void;

export type LoggingImplementation = {
  logError: Logger;
  logWarn: Logger;
};

export const defaultImplementation: LoggingImplementation = {
  logError: () => {},
  logWarn: () => {},
};

export const { logError, logWarn, registerImplementation } =
  createStubImplementation('@ardoq/logging', defaultImplementation);
